
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanyTreeNode } from 'app/modules/fuse/components/tree-view/entities/selected-company.model';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import {CompanySideBarTreeViewService} from '../../services/company-side-bar-tree-view.service'
import { PageLoaderService } from 'app/modules/common/services/page-loader.service'


@Component({
    selector: 'app-move-company',
    templateUrl: './move-company.component.html',
    styleUrls: ['./move-company.component.scss'],
    standalone: false
})
export class MoveCompanyComponent implements OnInit, AfterViewInit {


  public selectedEmpresaId: any =1;
  saveButtontext:string="Guardar"
  constructor(
    private _dialog: MatDialog,
    private _companyTreeService: CompanyTreeViewService,
    private _companySideBarTreeViewService : CompanySideBarTreeViewService,
    private _cdRef: ChangeDetectorRef,
    private _sharedService: SharedService,
    public _dialogRef: MatDialogRef<MoveCompanyComponent>,
    private _pageLoaderService: PageLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    

  }

  ngAfterViewInit(): void {
    const company = new CompanyTreeNode();
    this._companyTreeService.setSelectedCompany(company);
    this._cdRef.detectChanges();
  }

  ngOnInit(): void {

  }

  public onCompanySelcted(node: any): void 
  {
    this.selectedEmpresaId = node.id; 
  }

  moveCompany()
  {
    this.saveButtontext="Guardar"
    this._pageLoaderService.ShowPageLoader();
    this._companySideBarTreeViewService.MoveCompany(this.data.empresaId,this.selectedEmpresaId).subscribe(result => {
      if (result.result==0) {
        this._pageLoaderService.HidePageLoader();
        this.cancel();
        this._sharedService.ShowSnackBar('No se puede mover la compañía', 'Okay', 2000);
      } else if(result.result==1) {
        this.cancel();
        this._pageLoaderService.HidePageLoader();
        this._sharedService.ShowSnackBar('empresa movida con éxito', 'Okay', 2000);
      }
    }, err => {
      this._pageLoaderService.HidePageLoader();
      this.cancel();
      console.error(err);
      this._sharedService.ShowSnackBar('Api request failed', 'Okay', 2000);
    });
   
  }
  cancel() 
  {
    this._dialogRef.close();
  }

}
